import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as Styled from './styled';
import type { InputLabelProps } from './types';

export * from './types';

export const InputLabel: FC<InputLabelProps> = (props) => {
  const {
    icon,
    extra,
    required = false,
    optional = false,
    children,
    size = 'normal',
    requiredColor = 'red',
    color = 'medium',
  } = props;
  const { translate } = useTranslation();

  return (
    <Styled.Wrapper size={size} color={color}>
      {!!icon && <Styled.IconWrapper>{icon}</Styled.IconWrapper>}
      {children}
      {required === true ? (
        <Styled.RequiredWrapper requiredColor={requiredColor}>*</Styled.RequiredWrapper>
      ) : null}
      {!!optional && <Styled.OptionalWrapper>{translate('(Optional)')}</Styled.OptionalWrapper>}
      {extra}
    </Styled.Wrapper>
  );
};
